import './HomePage.css';

export const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      <div className="coming-soon-wrapper">
        <div className="coming-soon-card">
          <img
            src="/Gemini_Generated_logo_v2_full.png"
            alt="Translayshun"
            className="coming-soon-logo"
          />
          <div className="coming-soon-divider" />
          <h1 className="coming-soon-heading">Coming Soon</h1>
          <p className="coming-soon-text">
            Context-aware translation — done properly.
          </p>
          <p className="coming-soon-subtext">
            We're putting the finishing touches on something special. Check back soon.
          </p>
        </div>
        <footer className="coming-soon-footer">
          &copy; {new Date().getFullYear()} Translayshun. All rights reserved.
        </footer>
      </div>
    </div>
  );
};
